var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoChoiz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9751 22.6289H20.0247C10.9836 22.6289 3.6543 29.9582 3.6543 38.9993C3.6543 48.0404 10.9836 55.3696 20.0247 55.3696H57.9751C67.0162 55.3696 74.3455 48.0404 74.3455 38.9993C74.3455 29.9582 67.0162 22.6289 57.9751 22.6289Z",
    stroke: "#FAF9F6",
    strokeWidth: 5.4205
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5614 49.088C51.865 49.088 47.2656 44.5608 47.2656 39.027C47.2656 33.4446 51.8654 28.918 57.5614 28.918C63.2575 28.918 67.8572 33.4446 67.8572 39.027C67.8569 44.561 63.2578 49.088 57.5614 49.088Z",
    fill: "#FAF9F6",
    stroke: "#FAF9F6",
    strokeWidth: 0.281114
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoChoiz);
export default __webpack_public_path__ + "static/media/logo-choiz.5f11330f798d1273f691bbc1b470350f.svg";
export { ForwardRef as ReactComponent };